const Header = () => {
  return (
    <>
      <div className="absolute w-full bg-primary dark:hidden min-h-75"></div>
    </>
  );
};
export default Header;
